module.exports = __webpack_public_path__ + "static/interstate-light-7728b3f16f51e642a0c1079ab0a53e42.woff";